import './components.scss'
import Logo from '../../../assets/images/logo.png'
import { Icon } from '@iconify/react'
import { useNavigate } from 'react-router-dom'
import { useGlobalContext } from '../../../utils/Context'

function Sidebar({ page }: any) {
  const { toggleSidebar } = useGlobalContext()
  const navigate = useNavigate()
  return (
    <div className={`sidebar ${toggleSidebar ? 'active' : ''}`}>
      <div className='sidebar-cover'>
        <div className='logo'>
          <img src={Logo} alt='qc express logo' />
        </div>
        <ul>
          <li
            className={`flex ${page === 'home' ? 'active' : ''}`}
            onClick={() => navigate('/developer/home')}
          >
            <div>
              <Icon icon='lucide:home' />
            </div>
            <p>Dashboard</p>
          </li>
          <li
            onClick={() => navigate('/developer/bookings')}
            className={`flex ${page.includes('booking') ? 'active' : ''}`}
          >
            <div>
              <Icon icon='icon-park-outline:tickets-two' />
            </div>
            <p>Bookings</p>
          </li>
          <li
            onClick={() => navigate('/developer/transactions')}
            className={`flex ${page === 'transactions' ? 'active' : ''}`}
          >
            <div>
              <Icon icon='bitcoin-icons:transactions-outline' />
            </div>
            <p>Transactions</p>
          </li>
          <li
            onClick={() => navigate('/developer/debt-batches')}
            className={`flex ${page === 'debt-batches' ? 'active' : ''}`}
          >
            <div>
              <Icon icon='mdi:receipt-text-clock-outline' />
            </div>
            <p>Debt Batches</p>
          </li>
          <li
            onClick={() => navigate('/developer/weight-discrepancy')}
            className={`flex ${page === 'weight-discrepancy' ? 'active' : ''}`}
          >
            <div>
              <Icon icon='mdi:scale-balance' />
            </div>
            <p>Weight Discrepancy</p>
          </li>
          <li
            onClick={() => navigate('/developer/drop-off')}
            className={`flex ${page === 'drop-off' ? 'active' : ''}`}
          >
            <div>
              <Icon icon='pepicons-pop:map-circle' />
            </div>
            <p>Drop-off</p>
          </li>
          <li
            onClick={() => navigate('/developer/webhooks')}
            className={`flex ${page === 'webhooks' ? 'active' : ''}`}
          >
            <div>
              <Icon icon='hugeicons:api' />
            </div>
            <p>Webhooks</p>
          </li>
          <li
            onClick={() => navigate('/developer/settings')}
            className={`flex ${page === 'settings' ? 'active' : ''}`}
          >
            <div>
              <Icon icon='lets-icons:setting-fill' />
            </div>
            <p>Settings</p>
          </li>
          <a
            href='https://documenter.getpostman.com/view/39127318/2sAYk8tMq2'
            target='_blank'
            rel='noopener noreferrer'
          >
            <li className={`flex `}>
              <div>
                <Icon icon='hugeicons:document-code' />
              </div>
              <p>Documentation</p>
            </li>
          </a>
          <li
            onClick={() => {
              sessionStorage.clear()
              window.location.replace('/')
            }}
            className='flex'
          >
            <div>
              <Icon icon='line-md:log-out' />
            </div>
            <p>Log Out</p>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
